import {
  Auth0Client,
  Auth0ClientModel,
  AuthConfiguration,
  authService as auth0Service,
  AuthService as Auth0Service,
  User
} from '@aglenergy/agl.sales.authentication';
import { SessionStorageKeys } from '@aglenergy/shared-library';
import { Observable } from 'rxjs';
import { configService } from 'app/shared/services/config/config.service';
import { isLocalDevelopment } from 'app/shared/utilities/helper-functions';
import { locationService } from 'app/shared/services/location/location-service';

export class AuthenticationService {
  private readonly authClient: Auth0Service = auth0Service;

  public async getAuthConfiguration(): Promise<AuthConfiguration> {
    const authConfig: Auth0ClientModel = await configService.getAuthConfigData();
    return {
      authConfig: { ...authConfig, saml_login_url: await configService.getSamlLoginURL() },
      preLoginRedirectCallback: (redirectUrl) => {
        if (isLocalDevelopment()) {
          locationService.navigateToUrl(`returnPath=${redirectUrl}`);
          return;
        }
      }
    };
  }

  public getAuth0Client(): Auth0Client {
    return this.authClient.getAuth0Client();
  }

  public initialise(): Promise<boolean> {
    return this.getAuthConfiguration().then((configuration) => this.authClient.initialise(configuration));
  }

  public login(redirectUri = ''): Observable<void> {
    return this.authClient.login(redirectUri);
  }

  public getApiAuthToken(): Promise<string | null> {
    return this.authClient.getApiAuthToken();
  }

  public logout(returnRoute?: string): Promise<void> {
    return this.authClient.logout(returnRoute);
  }

  public get loggedIn(): boolean {
    return this.authClient.isLoggedIn() || !!sessionStorage.getItem(SessionStorageKeys.AccessToken);
  }

  public get user(): User {
    return this.authClient.getAuthenticatedUser();
  }

  public resetInstance(): void {
    this.authClient.resetInstance();
  }
}

export const authenticationService = new AuthenticationService();
